import { render, staticRenderFns } from "./actie.vue?vue&type=template&id=6278562b"
import script from "./actie.vue?vue&type=script&lang=js"
export * from "./actie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports